import "./Loader.css";

const Loader = () => {
    return (
        <div className="loading">
            <div></div>
        </div>
    )
}

export default Loader
